import type { BatteryProposalPersonDto } from "~/api/dto/battery-proposal.dto"
import { formatPhone } from "~/utils/formatPhone"

export const personName = (
  person: BatteryProposalPersonDto,
  fallback: string,
): string =>
  [person.firstName, person.lastName]
    .map((part) => part.trim())
    .filter(Boolean)
    .join(` `) || fallback

/**
 * Only a real 10-digit national number is reshaped; anything else — an
 * extension, an international number, a partial — is shown as stored rather
 * than mangled into a parenthesised fragment.
 */
export const formatPersonPhone = (phone: string | null): string | null => {
  if (!phone) {
    return null
  }

  const digits = phone.replace(/\D/g, ``)
  if (!digits) {
    return null
  }

  const national =
    digits.length === 11 && digits.startsWith(`1`) ? digits.slice(1) : digits
  if (national.length !== 10) {
    return phone
  }

  return formatPhone(phone)
}
